import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { mentionApi, mentionEvent } from './api';
export function useMentionCount(team = false) {
  const user = useSelector((state: any) => state.auth?.user?._id);
  const [count, setCount] = useState(0);
  useEffect(() => {
    let live = true;
    let busy = false;
    setCount(0);
    const refresh = async () => {
      if (!user || document.hidden || busy) return;
      busy = true;
      try {
        const { data } = await axios.get(mentionApi('/count', team), { withCredentials: true });
        if (live) setCount(data.count || 0);
      } catch (error) {
        if (live && axios.isAxiosError(error) && [401, 403].includes(error.response?.status || 0))
          setCount(0);
        /* next focus retries */
      } finally {
        busy = false;
      }
    };
    refresh();
    const interval = setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener(mentionEvent(team), refresh);
    return () => {
      live = false;
      clearInterval(interval);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener(mentionEvent(team), refresh);
    };
  }, [user, team]);
  return count;
}
